var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"appLayout",attrs:{"direction":"vertical"}},[_c('Header',{staticClass:"appHeader"}),_c('Content',{staticClass:"appContent"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }